import { AxiosResponse } from "axios";

import API from "../api";
import { Comment } from "../models/comment";

const ROUTE_NAME = "comments";

const CommentService = {
  async getAll(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(comment: Comment): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, comment);
  },
};

export default CommentService;
